export default (seatsBus, tripsSlug) => {
  return tripsSlug.some((tripId) => Object.keys(seatsBus).includes(tripId));
};
